import React from 'react'

export default function Dashboard() {
    return (
        //Visualization
        <div className='content-outline mt-4 text-center bg-white display-4'>Dashboard</div>
    )
}